import * as Yup from 'yup';
import Link from 'next/link';
import { useFormik } from 'formik';
import React, { useEffect } from 'react';

import { TextInput, SubmitButton } from '../form-elements';
import { NewOTPInputs, NewOTPErrors } from '../../../redux/auth/interfaces';
import { withAnalytics, WithAnalyticsProps } from '../../../HOC/with-analytics';

type RequestOTPFormProps = {
  errors: NewOTPErrors;
  hasOTP?: boolean;
  isGettingOTP?: boolean;
  requestOTP: (phoneNumber: string) => void;
} & WithAnalyticsProps;

const OTPRequestForm: React.SFC<RequestOTPFormProps> = (props) => {
  const initialValues: NewOTPInputs = { phoneNumber: '' };

  const formik = useFormik({
    initialValues,
    onSubmit: ({ phoneNumber }) => {
      props.requestOTP(phoneNumber);
    },
    validationSchema: Yup.object().shape({
      phoneNumber: Yup.string()
        .required('Phone Number is required')
        .matches(/^(?:0)?[0]?([1-9][0-9][0-9]{7})$/, 'Phone Number is invalid'),
    }),
  });

  const _handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    props.sendAnalytics('clickRequestOTP', 'Auth');
    formik.submitForm();
  };

  useEffect(() => {
    if (!props.isGettingOTP) {
      formik.setSubmitting(false);
      if (Object.keys(props.errors || {}).length > 0) formik.setErrors(props.errors);
    }
  }, [props.isGettingOTP]);

  const { values, errors, touched, isSubmitting, ...formProps } = formik;

  return (
    <div className="max-w-md mx-auto px-4">
      <p className="text-header text-center text-3xl sm:text-4xl leading-tight tracking-wide font-bold">
        Forgot Password?
      </p>

      <p className="text-center font-normal text-sm lg:font-medium mt-1 sm:text-lg py-2 mb-6">
        No worries, let us help you get back in.
      </p>

      <form onSubmit={_handleSubmit}>
        <div className="form-row">
          <TextInput
            type="text"
            name="phoneNumber"
            value={values.phoneNumber}
            errors={errors.phoneNumber}
            placeholder="Registered Phone Number"
            handleBlur={formProps.handleBlur}
            handleChange={formProps.handleChange}
            hasError={errors.phoneNumber && touched.phoneNumber}
          />
        </div>

        <p className="mt-4 text-sm">
          I remember my Password now? {''}
          <Link href="/signin">
            <a className="text-secondary">Let me Sign In</a>
          </Link>
        </p>

        {(errors as NewOTPErrors).submit && (
          <div className="p-3 text-red-600 font-light bg-red-300 rounded text-sm my-4">
            {(errors as NewOTPErrors).submit}
          </div>
        )}

        <SubmitButton
          direction="right"
          title="Continue"
          isDirty={formProps.dirty}
          loadingMsg="Processing..."
          isSubmitting={isSubmitting}
          className="mt-6 mx-auto1 afloat-right"
        />
      </form>
    </div>
  );
};

export default withAnalytics(OTPRequestForm);
